import { useState, useRef, useEffect } from "react";
import { HOVER_DEBOUNCE_TIME_MS } from "../utils/Constants";

function useHover<T extends HTMLElement>(delay = HOVER_DEBOUNCE_TIME_MS) {
  const [isHovered, setIsHovered] = useState(false);
  const ref = useRef<T>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleMouseEnter = () => {
      timeoutRef.current = setTimeout(() => {
        setIsHovered(true);
      }, delay);
    };

    const handleMouseLeave = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      setIsHovered(false);
    };

    const element = ref.current;
    if (element) {
      element.addEventListener("mouseenter", handleMouseEnter);
      element.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      if (element) {
        element.removeEventListener("mouseenter", handleMouseEnter);
        element.removeEventListener("mouseleave", handleMouseLeave);
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [delay]);

  return { ref, isHovered };
}

export default useHover;
